
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/platform/sourcing-and-production/products",
      function () {
        return require("private-next-pages/platform/sourcing-and-production/products/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/platform/sourcing-and-production/products"])
      });
    }
  